export const getListOfWhatsAppAccounts = {
    GET_LIST_OF_WHATSAPP_ACCOUNTS_REQUEST: "GET_LIST_OF_WHATSAPP_ACCOUNTS_REQUEST",
    GET_LIST_OF_WHATSAPP_ACCOUNTS_SUCCESS: "GET_LIST_OF_WHATSAPP_ACCOUNTS_SUCCESS",
    GET_LIST_OF_WHATSAPP_ACCOUNTS_ERROR: "GET_LIST_OF_WHATSAPP_ACCOUNTS_ERROR",
    GET_COUNT_OF_WHATSAPP_ACCOUNTS_REQUEST: "GET_COUNT_OF_WHATSAPP_ACCOUNTS_REQUEST",
    GET_COUNT_OF_WHATSAPP_ACCOUNTS_SUCCESS: "GET_COUNT_OF_WHATSAPP_ACCOUNTS_SUCCESS",
    GET_COUNT_OF_WHATSAPP_ACCOUNTS_ERROR: "GET_COUNT_OF_WHATSAPP_ACCOUNTS_ERROR"
  };
  